import React from "react";
import styles from "../css/Download.css";
import { Header } from "./Introduce";
import { Toast } from "antd-mobile";
import { request } from "../request";

const Item = ({ file }) => {
  return (
    <a
      // href={"http://liangql.tsinghua.site/" + file.path_file}
      href={"#/testDetail/" + file.id}
      className={styles.item}
    >
      <div className={styles.fileName}>{file.file_name}</div>
      <i
        className="iconfont icon-you"
        style={{ color: "#666666", fontSize: "14px" }}
      ></i>
    </a>
  );
};

class App extends React.Component {
  state = {
    data: [{ files: [] }],
  };

  componentDidMount() {
    request("index/getDataFile", { type: "资料" }, ({ data }) => {
      if (data.code === 1) {
        console.log(data.data, "data.data");
        this.setState({
          data: data.data,
        });
      } else {
        Toast.fail("获取设备失败");
      }
    });
  }

  render() {
    return (
      <div style={{ backgroundColor: "white", paddingBottom: "20px" }}>
        <Header text="技术资料"></Header>

        {this.state.data.map((item, index) => (
          <div className={styles.main}>
            <p className={styles.title}>{item.type_name}</p>
            {item.files.map((item) => (
              <Item file={item}></Item>
            ))}
          </div>
        ))}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/pages/Download.js